export enum BulkRecalculatePriceSelectionScope {
  All = "all",
  WithPriceRateOnly = "withPriceRateOnly",
  WithoutPriceRateOnly = "withoutPriceRateOnly",
  WithClientPriceRateWithoutSupplierPriceRate = "withClientPriceRateWithoutSupplierPriceRate",
  WithSupplierPriceRateWithoutClientPriceRate = "withSupplierPriceRateWithoutClientPriceRate",
}
